/* eslint-disable react/jsx-key */
"use client";

import React, { useEffect } from "react";
import PortfolioColorscheme from "@/app/components/PortfolioColorscheme/PortfolioColorscheme";
import PortfolioResponsiveDisplays from "@/app/components/PortfolioResponsiveDisplays/PortfolioResponsiveDisplays";
import PortfolioTypography from "@/app/components/PortfolioTypography/PortfolioTypography";
import WebsiteLogo from "@/app/components/WebsiteLogo/websitelogo";
import { WebsiteSubtitle } from "@/app/components/WebsiteSubtitle/WebsiteSubtitle";
import PortfolioTechStack from "@/app/components/PortfolioTechStack/PortfolioTechStack";
import FigmaLogo from "@/app/components/icons/figmaLogo";
import HTML5Logo from "@/app/components/icons/HTML5Logo";
import CSS3Logo from "@/app/components/icons/CSS3Logo";
import JSLogo from "@/app/components/icons/JSLogo";
import PHPLogo from "@/app/components/icons/PHPLogo";
import WordpressLogo from "@/app/components/icons/WordpressLogo";
import FirstBlockAbout from "@/components/common/FirstBlockAbout";

export default function Averlexx() {
  const primaryColor = "#086CF2";
  useEffect(() => {
    // Dynamically add the Google font to the document head
    const link = document.createElement("link");
    link.href =
      "https://fonts.googleapis.com/css2?family=Urbanist:wght@400;700&display=swap";
    link.rel = "stylesheet";
    document.head.appendChild(link);

    return () => {
      document.head.removeChild(link); // Cleanup on unmount
    };
  }, []);

  return (
    <>
      <section className="flex flex-col gap-[100px] my-[35px]">
        <div>
          <WebsiteLogo imageSrc="https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FPortfolio%20Image%20For%20Each%20Project%2FAverlexx%2Faverlexxlogo.webp?alt=media&token=286e3ef8-e900-4667-9a5b-b58dcb04ff58" />
          <FirstBlockAbout
            media={{
              type: "image",
              src: "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FPortfolio%20Image%20For%20Each%20Project%2FAverlexx%2Faverlexx.webp?alt=media&token=e4b23d6f-77b9-47aa-82c6-d52aa6b54af0",
            }}
            primaryColor={primaryColor}
          />
          <WebsiteSubtitle
            text="For Averlexx Cleaning Service, we provided a comprehensive launchpad for their business by crafting a unique brand identity starting with a professional logo. We then designed and developed a custom WordPress theme and website, creating a tailored online presence that effectively showcases their range of cleaning solutions. To ensure local visibility from the outset, we implemented foundational SEO strategies, giving Averlexx the essential tools to establish their presence and begin attracting clients in their service area."
            title="Deliverables"
            tags={["TYPOGRAPHY", "COLORSCHEME", "RESPONSIVE DESIGN", "TECH STACK"]}
            buttonHref="https://averlexx.com/"
          />
        </div>

        <PortfolioTypography
          typographyData={[
            {
              headline:
                "Excellence in Cleaning Services: delivering unmatched quality and meticulous attention to detail.",
              fontFamily: "Urbanist",
              fontSize: "48px",
              letterSpacing: "0%",
              lineHeight: "auto",
              textColor: "#086CF2",
            },
          ]}
          primaryColor={primaryColor}
        />
        <PortfolioColorscheme
          ColorschemeData={[
            {
              title: "Main color",
              color: "#086CF2",
              rgb: "#086CF2",
              textColor: "#FFFFFF",
            },
            {
              title: "White",
              color: "#FFFFFF",
              rgb: "#FFFFFF",
              textColor: "#2c2d2c",
            },
            {
              title: "Gray",
              color: "#E9EDF3",
              rgb: "#E9EDF3",
              textColor: "#2c2d2c",
            },
            {
              title: "Black",
              color: "#2C2D2C",
              rgb: "#2C2D2C",
              textColor: "#FFFFFF",
            },
          ]}
          primaryColor={primaryColor}
        />
        <PortfolioResponsiveDisplays
          ResponsiveDisplaysData={[
            {
              type: "image",
              content:
                "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FPortfolio%20Image%20For%20Each%20Project%2FAverlexx%2Faverlexxpc.webp?alt=media&token=7a6cdbe7-833c-4f52-9412-f7bebe0a518c",
            },
            {
              type: "image",
              content:
                "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FPortfolio%20Image%20For%20Each%20Project%2FAverlexx%2Faverlexxipad.webp?alt=media&token=a28f0467-7c55-4c28-8426-41f75231b3dc",
            },
            {
              type: "image",
              content:
                "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FPortfolio%20Image%20For%20Each%20Project%2FAverlexx%2Faverlexxmobile.webp?alt=media&token=0d0e7810-3534-4901-afcb-70df67c7c3cc",
            },
          ]}
          primaryColor={primaryColor}
        />
        <PortfolioTechStack
          primaryColor={primaryColor}
          blocks={[
            {
              title: "Design",
              icons: [<FigmaLogo />],
              opacity: 5,
            },
            {
              title: "Layout Development",
              icons: [<HTML5Logo />, <CSS3Logo />, <JSLogo />],
              opacity: 15,
            },
            {
              title: "Theme Development",
              icons: [<PHPLogo />],
              opacity: 25,
            },
            {
              title: "Publishing",
              icons: [<WordpressLogo />],
              opacity: 30,
            },
          ]}
        />
      </section>
    </>
  );
}
